import React from 'react'

/**
 * COMPONENTE: Tombola OVERLAY (VISUAL CHILD)
 * ------------------------------------------------------------------
 * Renderiza el widget "En Vivo" (Insignia) aplicando la configuración.
 * ------------------------------------------------------------------
 */
const Tombola = ({ config }) => {
    const {
        visible,
        designStyle,
        scale,
        speed,
        position,
        color,
        glow,
        offsetX,
        offsetY,
        expanded,
        activeLiveBadge
    } = config;

    const badgeData = activeLiveBadge || {
        text: 'EN VIVO',
        logoDataUrl: null,
        showLogo: true
    };

    // Helper para convertir hexadecimal a "r, g, b" para las transparencias CSS
    const hexToRgb = (hex) => {
        if (!hex) return '255, 0, 60';
        const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        const fullHex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : '255, 0, 60';
    };

    const rgbColor = hexToRgb(color);

    // Generar un logotipo SVG por defecto coloreado con el color seleccionado
    const defaultLogoSvg = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'><circle cx='50' cy='50' r='48' fill='%23ffffff'/><circle cx='50' cy='50' r='30' fill='none' stroke='${encodeURIComponent(color)}' stroke-width='6'/><circle cx='50' cy='50' r='12' fill='${encodeURIComponent(color)}'/></svg>`;

    // Clases dinámicas
    const shouldShowLogo = designStyle === 'logo' && badgeData.showLogo;
    const badgeClasses = `live-badge ${visible ? '' : 'hide'} ${shouldShowLogo ? 'style-logo-capsule' : 'style-simple'}`;

    // Estilos dinámicos inyectados como variables CSS locales
    const cssVariablesStyle = {
        '--badge-color': color,
        '--badge-color-rgb': rgbColor,
        '--badge-scale': scale,
        '--badge-speed': `${speed}s`,
        '--badge-glow': `${glow}px`
    };

    const widgetStyle = {
        position: 'absolute',
        left: `${offsetX ?? 90}%`,
        top: `${offsetY ?? 8}%`,
        transform: `translate(-50%, -50%) scale(${scale})`,
        transformOrigin: 'center center',
        zIndex: 2
    };

    return (
        <div className="badge-display-container" style={{ ...cssVariablesStyle, position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, overflow: 'hidden' }}>
            {/* Si está expandido, renderizamos un fondo oscuro completo estilo Portada/Soporte */}
            {expanded && (
                <div style={{
                     position: 'absolute',
                     width: '100%',
                     height: '100%',
                     top: 0,
                     left: 0,
                     background: 'radial-gradient(circle at center, #151620 0%, #06070a 100%)',
                     zIndex: 1,
                     pointerEvents: 'none'
                }} />
            )}

            <div className={badgeClasses} style={widgetStyle}>
                
                {/* Frame de Logo (Solo visible en estilo 'logo') */}
                {shouldShowLogo && (
                    <div className="badge-circle-frame">
                        <div className="badge-logo-inner">
                            <img 
                                id="badge-custom-logo" 
                                src={badgeData.logoDataUrl ? badgeData.logoDataUrl : defaultLogoSvg} 
                                alt="Logo Insignia" 
                            />
                        </div>
                    </div>
                )}

                {/* Cápsula de Texto */}
                <div className="badge-pill" style={{ whiteSpace: 'nowrap' }}>
                    <span className="live-dot"></span>
                    <span id="live-text-display" style={{ whiteSpace: 'nowrap' }}>{badgeData.text}</span>
                </div>

            </div>
        </div>
    );
};

export default Tombola;
export { Tombola };
